class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.getSelectedOptions();
    this.getSelectedVariant();

    if (this.currentVariant) {
      this.updateUrl();
      this.updateFormId();
      this.updatePrice();
      this.updatePreOrderNotifyBtn();
      this.updateAvailability();
    }
  }

  getSelectedOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  getVariantJson() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('#CusVariantsData').textContent);
    this.metaFieldsData = this.metaFieldsData || JSON.parse(this.querySelector('#PreorderMetafieldsMap').textContent);

    return this.variantData;
  }

  getSelectedVariant() {
    this.currentVariant = this.getVariantJson().find((variant) => {
      const findings = !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);

      if (findings) return variant;
    });
  }

  updateUrl() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateFormId() {
    const form_input = document.querySelector("#custom-product-form").querySelector('input[name="id"]');

    form_input.value = this.currentVariant.id;
  }

  updatePrice() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        const oldPrice = document.getElementById(id);
        const newPrice = html.getElementById(id);
        if (oldPrice && newPrice) oldPrice.innerHTML = newPrice.innerHTML;
      });
  }

  updatePreOrderNotifyBtn() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `notify_me_btn-${this.dataset.section}`;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        const oldBtn = document.getElementById(id);
        const newBtn = html.getElementById(id);
        const parentContainer = oldBtn.parentNode;

        if (parentContainer && oldBtn && newBtn) {
          parentContainer.replaceChild(newBtn, oldBtn);
        }
      });
  }

  updateAvailability () {
    const id = `atc_btn-${this.dataset.section}`;
    const personalizeBtnId = `personalize_atc_btn-${this.dataset.section}`;
    const availabilityTextElId = `availablity_text-${this.dataset.section}`;
    const preOrderNoteId = `pre_order_note-${this.dataset.section}`;
    const notifyMeBtnId = `notify_me_btn-${this.dataset.section}`;

    // Update Add To Cart Button
    const btn = document.querySelector(`#${id}`);
    if (btn) {
      const btnTextEl = btn.querySelector('.atc_text');
  
      if (this.currentVariant.available) {
        if (btnTextEl) btnTextEl.textContent = "Add to Cart";
        btn.removeAttribute("disabled");
      } else {
        if (btnTextEl) btnTextEl.textContent = "Sold Out";
        btn.setAttribute("disabled",'');
      }
    }

    // Update Personalize Drawer ATC Button
    const personalizeBtn = document.querySelector(`#${personalizeBtnId}`);
    if (personalizeBtn) {    
      const personalizeBtnTextEl = personalizeBtn.querySelector('.atc_text');
  
      if (this.currentVariant.available) {
        if (personalizeBtnTextEl) personalizeBtnTextEl.textContent = "Add to Cart";
        personalizeBtn.removeAttribute("disabled");
      } else {
        if (personalizeBtnTextEl) personalizeBtnTextEl.textContent = "Sold Out";
        personalizeBtn.setAttribute("disabled",'');
      }
    }

    // Update Availability Text if Product is on Pre-Order
    const isPreorder = this.metaFieldsData[this.currentVariant.id] === true;
    const availabilityEl = document.querySelector(`#${availabilityTextElId}`);
    const preOrderNoteEl = document.querySelector(`#${preOrderNoteId}`);
    const notifyMeBtn = document.querySelector(`#${notifyMeBtnId}`);


    if (isPreorder) {
      // btnTextEl.textContent = "Pre Order";
      // personalizeBtnTextEl.textContent = "Pre Order";

      if (notifyMeBtn) notifyMeBtn.setAttribute('data-active', '');
      if(preOrderNoteEl) preOrderNoteEl.setAttribute('data-active', '');

      if (availabilityEl) {
        availabilityEl.removeAttribute('data-low-stock');
        availabilityEl.setAttribute('data-preorder', '');
        availabilityEl.querySelector('p').textContent = 'Pre Order';
      }
    } else {
      if (notifyMeBtn) notifyMeBtn.removeAttribute('data-active');
      if (preOrderNoteEl) preOrderNoteEl.removeAttribute('data-active');

      if (availabilityEl) {
        if (this.currentVariant.available) {
          availabilityEl.removeAttribute('data-preorder');
          availabilityEl.removeAttribute('data-low-stock');
          availabilityEl.querySelector('p').textContent = 'In Stock';
        } else {
          availabilityEl.removeAttribute('data-preorder');
          availabilityEl.setAttribute('data-low-stock', '');
          availabilityEl.querySelector('p').textContent = 'Out of Stock';
        }
      }
    }
  }
}

customElements.define("variant-selector", VariantSelector);
